import { Download } from '@profgeosoft-ui/icons';
import { Button, Checkbox, DatePickerV2, Modal } from '@profgeosoft-ui/react';
import { minutesToSeconds } from 'date-fns';
import { observer } from 'mobx-react-lite';
import { hasValue } from 'src/shared/utils/common';

import { ExportStore, fixDatePickerTime } from './export-store';

import styles from './export.module.scss';

type Props = {
  exportStore: ExportStore;
};

export const ExportModal = observer<Props>(function ExportModal({ exportStore }) {
  const {
    viewData: { startDate, endDate, wellList, gantt, wellPadPreparations },
    isModalOpen,
    error,
    updateData,
    setIsModalOpen,
    resetModalData,
  } = exportStore;

  const onCancel = () => {
    if (!error) {
      resetModalData();
    }

    setIsModalOpen(false);
  };

  return (
    <Modal open={isModalOpen} title="Экспорт данных" onClose={() => setIsModalOpen(false)} onClickOutside={null}>
      <div className={styles.wrapper}>
        <div className={styles.inputsWrapper}>
          <div className={styles.intervalWrapper}>
            <p className={styles.intervalLabel}>Период выгрузки</p>
            <div className={styles.intervalInputsWrapper}>
              <DatePickerV2
                placeholder={'Дата "От"'}
                className={styles.datePicker}
                value={startDate}
                allowClear={false}
                onChange={(startDate) => {
                  if (!hasValue(startDate)) {
                    return;
                  }

                  updateData({ startDate });
                }}
              />
              —
              <DatePickerV2
                placeholder={'Дата "До"'}
                className={styles.datePicker}
                value={endDate}
                isDateDisabled={(date) => {
                  const dateInst = new Date(date * 1000);
                  const timezoneOffset = dateInst.getTimezoneOffset();

                  const fixedDate = fixDatePickerTime(date - minutesToSeconds(timezoneOffset));

                  return fixedDate < startDate;
                }}
                onChange={(endDate) => updateData({ endDate })}
              />
            </div>
          </div>

          <label className={styles.tagWrapper}>
            <Checkbox checked={wellList} onChange={(checked) => updateData({ wellList: checked })} />
            <p className={styles.tagLabel}>Список скважин</p>
          </label>

          <label className={styles.tagWrapper}>
            <Checkbox checked={gantt} onChange={(checked) => updateData({ gantt: checked })} />
            <p className={styles.tagLabel}>Диаграмма Ганта</p>
          </label>

          {exportStore.isWPPAvailable && (
            <label className={styles.tagWrapper}>
              <Checkbox
                checked={wellPadPreparations}
                onChange={(checked) => updateData({ wellPadPreparations: checked })}
              />
              <p className={styles.tagLabel}>Подготовка КП</p>
            </label>
          )}
        </div>

        <div className={styles.buttonsWrapper}>
          <Button variant="danger" className={styles.button} onClick={onCancel}>
            Отменить
          </Button>
          <Button variant="success" className={styles.button} icon={<Download />} onClick={exportStore.export}>
            Экспорт
          </Button>
        </div>
      </div>
    </Modal>
  );
});
